import * as React from 'react';

const SvgCardBannerOptional2 = (props) => (
  <svg
    width={324}
    height={80}
    viewBox="0 0 324 80"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <linearGradient
        x1="0%"
        y1="50.692%"
        x2="100%"
        y2="49.459%"
        id="card-banner-optional-2_svg__d"
      >
        <stop stopColor="#FF5F00" offset="0%" />
        <stop stopColor="#FF761C" offset="100%" />
      </linearGradient>
      <rect
        id="card-banner-optional-2_svg__a"
        x={0}
        y={0}
        width={324}
        height={80}
        rx={6}
      />
      <path id="card-banner-optional-2_svg__c" d="M0 0h1700v200H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="card-banner-optional-2_svg__b" fill="#fff">
        <use xlinkHref="#card-banner-optional-2_svg__a" />
      </mask>
      <use fill="#078CDF" xlinkHref="#card-banner-optional-2_svg__a" />
      <g mask="url(#card-banner-optional-2_svg__b)">
        <g transform="translate(-790 -120)">
          <mask id="card-banner-optional-2_svg__e" fill="#fff">
            <use xlinkHref="#card-banner-optional-2_svg__c" />
          </mask>
          <use
            fill="url(#card-banner-optional-2_svg__d)"
            xlinkHref="#card-banner-optional-2_svg__c"
          />
          <g fill="#FFF" mask="url(#card-banner-optional-2_svg__e)">
            <path d="m1052.527 164.585-41.365-20.555-.162.333L1052.527 165l.081-.04L1094 144.334l-.162-.334zM1053.1 219h.8v-54h-.8zM993.447 162.04 952 182.314v54.37l.102.05L993.527 257l18.663-9.128v-27.1l22.81-11.158v-27.328l-.102-.05L993.528 162l-.081.04Zm-41.08 74.418v-53.916l41.16-20.136 41.106 20.107v26.874l-22.81 11.158v27.1l-18.296 8.95-41.16-20.137Z" />
            <path d="m993.527 202.585-41.365-20.555-.162.333L993.527 203l.082-.04L1035 182.334l-.163-.334z" />
            <path d="m1052.527 124-.08.04L1011 144.314v27.27l.103.05 22.707 11.108v27.1l.102.05 18.615 9.107.081-.04L1094 198.714v-54.428l-.103-.05-41.37-20.236Zm-18.35 85.617v-27.1l-.103-.051-22.707-11.107v-26.817l41.16-20.136 41.106 20.107v53.974l-41.106 20.107-18.35-8.977ZM993.1 143h.8V89h-.8z" />
            <path d="M992.527 67.074 973.993 58 951 69.257v54.412l.103.05L992.527 144l.081-.04L1034 123.698v-54.47l-.103-.05L1011.063 58l-18.536 9.074Zm18.536-8.667 22.57 11.048v54.016l-41.106 20.122-41.16-20.15V69.483l22.626-11.077 18.534 9.073 18.536-9.073ZM831.055 186.17l-83.726-41.11-.329.666L831.055 187l.164-.08L915 145.667l-.329-.668zM832.199 296h1.602V187h-1.602zM711.892 181.08 628 222.057v109.884l.207.101L712.055 373l37.776-18.449v-54.769L796 277.23v-55.231l-.207-.102L712.055 181l-.163.08Zm-83.148 150.404V222.516l83.311-40.696 83.202 40.637v54.314l-46.17 22.552v54.769l-37.032 18.088-83.311-40.696Z" />
            <path d="m831.055 104-.164.08L747 145.057v55.115l.208.1 45.961 22.45v54.771l.207.101L831.056 296l.163-.08L915 255V145l-.208-.101L831.055 104Zm-37.143 173.036v-54.771l-.207-.103-45.961-22.447v-54.199l83.311-40.696 83.201 40.637v109.085l-83.2 40.637-37.144-18.143Z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SvgCardBannerOptional2;
